/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Injectable, Injector } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenService } from '../auth/token.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(public inj: Injector) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        route = route; // Just to use the variable
        let tokenService = this.inj.get(TokenService);
        let router = this.inj.get(Router);
        const token = tokenService.getToken();
        if (token instanceof Promise) {
            return token.then((tokenStr: String) => {
                if (tokenStr) {
                    return true;
                } else {
                    if (localStorage.getItem('currentUser')) {
                        // logged in so return true
                        return true;
                    }
                    const username = route.queryParams['username'];
                    router.navigate(['login'], { queryParams: { returnUrl: state.url, username: username }});
                    // router.navigate(['/login']);
                    return false;
                }
            });
        } else {
            if (token) {
                return true;
            } else {
                // router.navigate(['/login']);
                const username = route.queryParams['username'];
                router.navigate(['login'], { queryParams: { returnUrl: state.url, username: username }});

                return false;
            }
        }
    }

}
